import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import PaymentTypeForm from '../../../components/forms/PaymentTypeForm';
import { useCreatePaymentType } from '../../../hooks/usePaymentTypeApi';
import { useNavigate } from 'react-router-dom';
import { PaymentTypeDTO } from '../../../services/apiClient';

const PaymentTypeCreate: React.FC = () => {
  const createMutation = useCreatePaymentType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Payment Types', href: '/admin/paymenttypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: PaymentTypeDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/paymenttypes');
    } catch (error) {
      console.error('Error creating PaymentType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/paymenttypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.PaymentType.Edit'
    >
        <PaymentTypeForm
          initialValues={{} as PaymentTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/paymenttypes')}
        />
    </AdminLayout>
  );
};

export default PaymentTypeCreate;